import React from "react";
import classNames from "classnames/bind";

import styles from "./Pill.module.scss";
const cx = classNames.bind(styles);

const Pill = ({ label, classname, ...rest }) => {
  return (
    <span className={cx("pill-root", classname)} {...rest}>
      {label}
    </span>
  );
};

export default Pill;
